<template>
    <DefaultLayout>
        <UContainer>
            <div class="flex justify-between mt-8 gap-4">
                <div class="w-1/4" v-if="isDesktop">
                    <LayoutsDashboardMenu v-if="isDesktop" />
                </div>
                <div class="w-full lg:w-3/4">
                    <slot></slot>
                </div>
            </div>
        </UContainer>
    </DefaultLayout>
</template>

<script lang="ts" setup>
import DefaultLayout from "./default.vue";

const { isDesktop } = useDevice();
</script>
